import HeroSection from "./components/HeroSection";
import FeaturedSection from "./components/FeaturedSection";
import CategorySection from "./components/CategorySection";
import TimelineSection from "./components/TimelineSection";
import LatestSection from "./components/LatestSection";
import VoicesSection from "./components/VoicesSection";
import FaqSection from "./components/FaqSection";
import useSEO from "@/hooks/useSEO";
import { faqItems, heroImage, siteInfo } from "@/mocks/site";

const origin = typeof window !== "undefined" ? window.location.origin : "";

export default function Home() {
  useSEO({
    title: "爆料专区 | 年度盘点大事件 旧瓜复盘回顾",
    description:
      "爆料专区专注娱乐大事件年度盘点与旧瓜复盘，系统整理历史热点、新闻回顾与事件时间线，梳理来龙去脉，挖掘被遗忘的细节，适合老用户重温、新用户快速补课。",
    keywords: "爆料专区,年度盘点,大事件回顾,旧瓜复盘,历史热点,新闻回顾",
    canonical: "/",
    ogType: "website",
    image: heroImage,
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteInfo.name,
        url: `${origin}/`,
        description: siteInfo.intro,
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: `${origin}/archive?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteInfo.name,
        url: `${origin}/`,
        email: siteInfo.email,
        foundingDate: siteInfo.since,
        description: siteInfo.intro,
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqItems.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
    ],
  });

  return (
    <>
      <HeroSection />
      <FeaturedSection />
      <CategorySection />
      <TimelineSection />
      <LatestSection />
      <VoicesSection />
      <FaqSection />
    </>
  );
}